export default [{
    path: '/text_novels',
    component: resolve => require(['../../../view/find/text_Novels/text_Novels.vue'], resolve),
}, {
    path: '/text_list',
    component: resolve => require(['../../../view/find/text_Novels/text_list.vue'], resolve),
}, ]


// WEBPACK FOOTER //
// ./src/router/find/text_Novels/index.js